var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2493_2819)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2493_2819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 16.74C5.79 16.74 5.57248 16.6875 5.37749 16.5825C4.94999 16.3575 4.6875 15.9075 4.6875 15.4275V14.3626C2.4225 14.1301 0.9375 12.465 0.9375 10.08V5.58008C0.9375 3.00008 2.67 1.26758 5.25 1.26758H12.75C15.33 1.26758 17.0625 3.00008 17.0625 5.58008V10.08C17.0625 12.66 15.33 14.3925 12.75 14.3925H9.9225L6.72748 16.5226C6.50998 16.6651 6.255 16.74 6 16.74ZM5.25 2.38507C3.315 2.38507 2.0625 3.63757 2.0625 5.57257V10.0726C2.0625 12.0076 3.315 13.2601 5.25 13.2601C5.5575 13.2601 5.8125 13.5151 5.8125 13.8226V15.4201C5.8125 15.5176 5.8725 15.5626 5.91 15.5851C5.94751 15.6076 6.02251 15.6301 6.10501 15.5776L9.4425 13.3576C9.5325 13.2976 9.645 13.2601 9.7575 13.2601H12.7575C14.6925 13.2601 15.945 12.0076 15.945 10.0726V5.57257C15.945 3.63757 14.6925 2.38507 12.7575 2.38507H5.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99888 9.08206C8.69138 9.08206 8.43638 8.82706 8.43638 8.51956V8.36206C8.43638 7.49206 9.07388 7.06455 9.31388 6.89955C9.59138 6.71205 9.68138 6.58456 9.68138 6.38956C9.68138 6.01456 9.37388 5.70703 8.99888 5.70703C8.62388 5.70703 8.31638 6.01456 8.31638 6.38956C8.31638 6.69706 8.06138 6.95206 7.75388 6.95206C7.44641 6.95206 7.19141 6.69706 7.19141 6.38956C7.19141 5.39206 8.00138 4.58203 8.99888 4.58203C9.99638 4.58203 10.8064 5.39206 10.8064 6.38956C10.8064 7.24456 10.1764 7.67206 9.94388 7.82956C9.65138 8.02456 9.56138 8.15206 9.56138 8.36206V8.51956C9.56138 8.83456 9.30638 9.08206 8.99888 9.08206Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.9502C8.685 10.9502 8.4375 10.6952 8.4375 10.3877C8.4375 10.0802 8.6925 9.8252 9 9.8252C9.3075 9.8252 9.5625 10.0802 9.5625 10.3877C9.5625 10.6952 9.315 10.9502 9 10.9502Z",
    fill: "#BBBBBB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2493_2819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2493_2819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconTwo);
export default __webpack_public_path__ + "static/media/menu_icon_two.6ef1561dbbeb38e021258d67c8e28cba.svg";
export { ForwardRef as ReactComponent };